import actionsTypes from './actionTypes';
import {
  ChangeModalVisibilityAction,
  ClearStateAction,
  ProcessActionErrorAction,
  ProcessActionRequestAction,
  ProcessActionSuccessAction,
} from './actions.d';
import { IChangeModalVisibilityPayload, IProcessActionSuccessPayload, IProcessRequestPayload } from './types';

const actions = {
  processActionRequest: <T1, T2>(payload: IProcessRequestPayload<T1, T2>): ProcessActionRequestAction<T1, T2> => ({
    type: actionsTypes.PROCESS_ACTION_REQUEST,
    payload,
  }),

  processActionSuccess: (payload: IProcessActionSuccessPayload): ProcessActionSuccessAction => ({
    type: actionsTypes.PROCESS_ACTION_SUCCESS,
    payload,
  }),

  processActionError: (): ProcessActionErrorAction => ({
    type: actionsTypes.PROCESS_ACTION_ERROR,
  }),

  changeModalVisibility: (payload: IChangeModalVisibilityPayload): ChangeModalVisibilityAction => ({
    type: actionsTypes.CHANGE_MODAL_VISIBILITY,
    payload,
  }),

  clearState: (): ClearStateAction => ({
    type: actionsTypes.CLEAR_STATE,
  }),
};

export default actions;
